import { typographyToCss } from 'shared/lib/mui';
import styled from 'styled-components';

// Indented under the toggle's label (color bar + gap), so the hint reads as part of the calendar
// row rather than a menu entry of its own.
export const BlockedHint = styled.p`
  ${({ theme }) => typographyToCss(theme.typography.caption)};
  margin: 0;
  padding: 0 ${({ theme }) => theme.spacing(3)}
    ${({ theme }) => theme.spacing(1)};
  max-width: 28rem;
  color: ${({ theme }) => theme.palette.warning.main};
`;
